import React from "react";
import { useActionsProvidersIndex, useProviders } from "../../../../context/inventory/ProvidersIndexProvider";
import "../../../../app.css";
import "./CreateProvider.css";
import { faFloppyDisk, faSquarePlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const CreateProvider = () => {
  const state = useProviders();
  const action = useActionsProvidersIndex();
  const { edit_provider, for_edit } = state;
  const { name, doc_num, phone, email, address, genre, city } = edit_provider;

  return (
    <div>
      <div className="row">
        <div className="mb-3 col-md-2">
          <label className="form-label">Nombre</label>
          <input
            value={name}
            type="text"
            className="form-control"
            onChange={(e) => action.setFieldFormProvider(e.target.value, "name")}
          />
        </div>
        <div className="mb-3 col-md-2">
          <label className="form-label">Documento</label>
          <input
            value={doc_num}
            type="text"
            className="form-control"
            onChange={(e) => action.setFieldFormProvider(e.target.value, "doc_num")}
          />
        </div>
        <div className="mb-3 col-md-2">
          <label className="form-label">Teléfono</label>
          <input
            value={phone}
            type="text"
            className="form-control"
            onChange={(e) => action.setFieldFormProvider(e.target.value, "phone")}
          />
        </div>
        <div className="mb-3 col-md-2">
          <label className="form-label">Email</label>
          <input
            value={email}
            type="text"
            className="form-control"
            onChange={(e) => action.setFieldFormProvider(e.target.value, "email")}
          />
        </div>
        <div className="mb-3 col-md-2">
          <label className="form-label">Dirección</label>
          <input
            value={address}
            type="text"
            className="form-control"
            onChange={(e) => action.setFieldFormProvider(e.target.value, "address")}
          />
        </div>
        <div className="mb-3 col-md-1">
          <label className="form-label">Género</label>
          <input
            value={genre}
            type="text"
            className="form-control"
            maxLength={1}
            placeholder="M/F"
            onChange={(e) => action.setFieldFormProvider(e.target.value, "genre")}
          />
        </div>
        <div className="mb-3 col-md-2">
          <label className="form-label">Ciudad</label>
          <input
            value={city}
            type="text"
            className="form-control"
            onChange={(e) => action.setFieldFormProvider(e.target.value, "city")}
          />
        </div>
        <div className="div-for-btn-provider">
          <div
            onClick={() => (for_edit ? action.editProviderClick() : action.createProviderClick())}
            className="flex btn-default button-form-provider"
          >
            <FontAwesomeIcon className="margin-auto" icon={for_edit ? faFloppyDisk : faSquarePlus} />
            &nbsp;
            <span>{for_edit ? "Guardar" : "Crear"}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
